import React from "react";
import { Tabs } from "../../../../Common/UI/Index";
import { TabListProps } from "../../../../Common/UI/Tabs/Tabs";
import "../Styles.scss";

interface DialogNavTabsViewProps {
  /**
   * Select tab
   */
  onMenuSelect: (selectedMenu: string) => void;
  /**
   * Navigation menu item
   */
  menu: string;
  /**
   * Tablist for the output config dialog
   */
  tabsList: TabListProps[];
}

/**
 * Responsible to render nav tab in dialog box
 * @returns Nav tab in dialog box
 */
export const DialogNavTabsView: React.FC<DialogNavTabsViewProps> = (props: DialogNavTabsViewProps) => {
  const { onMenuSelect, tabsList, menu } = props;

  return (
    <div className="outputconfig-dialog-navigation" >
      <Tabs
        tabsList={tabsList}
        activeTab={menu}
        onTabChange={onMenuSelect}
      />
    </div>
  );
};
